import React from "react";

const AppTitle = ({ appName, price }) => {
  return (
    <div className="w-full px-6 lg:px-32 pt-10 pb-4">
      <div className="sm:flex justify-between items-start">
        <p className="text-xl font-bold text-black break-all sm:pr-5">{appName}</p>
        {Number(price) === 0 ? (
          <p className="text-lg text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center">Free</p>
        ) : (
          <p className="text-base text-black font-gmarket-medium font-bold min-w-max flex justify-end items-center">
            <span className="font-bold text-lg text-black mr-1">{price}</span> Credit
          </p>
        )}
      </div>
    </div>
  );
};
export default AppTitle;
